import {
    MarketingNewsletterSection,
    MarketingNewsletterSectionProps,
} from '../shared/marketing/MarketingNewsletterSection';

import { BigPicture, BigPictureProps } from './BigPicture/BigPicture';
import { DoublePictures, DoublePicturesProps } from './DoublePictures/DoublePictures';
import {
    DoublePictureWithDescription,
    DoublePictureWithDescriptionProps,
} from './DoublePictureWithDescription/DoublePictureWithDescription';
import { TriplePictures, TriplePicturesProps } from './TriplePictures/TriplePictures';
import { TwoColumnText, TwoColumnTextProps } from './TwoColumnText/TwoColumnText';

type Props = {
    slice:
        | DoublePictureWithDescriptionProps['doublePictureWithDescription']
        | BigPictureProps['bigPicture']
        | TwoColumnTextProps['twoColumnText']
        | DoublePicturesProps['doublePictures']
        | TriplePicturesProps['triplePictures']
        | MarketingNewsletterSectionProps['slice'];
    row: number;
};

export function Slice({ slice, row }: Props) {
    switch (slice.type) {
        case 'double_picture_with_description':
            return <DoublePictureWithDescription doublePictureWithDescription={slice} row={row} />;
        case 'big_picture':
            return <BigPicture bigPicture={slice} />;
        case 'two_column_text':
            return <TwoColumnText twoColumnText={slice} row={row} />;
        case 'double_picture':
            return <DoublePictures doublePictures={slice} />;
        case 'triple_picture':
            return <TriplePictures triplePictures={slice} />;
        case 'newsletter_section':
            return <MarketingNewsletterSection slice={slice} />;
        default:
            return null;
    }
}
